import { useUser } from '../contexts/UserContext';
import { FetchFnArgs } from '../types/apiTypes';
import { useAppView } from '../contexts/AppViewContext';

export const useQueryFnDeps = (): Omit<FetchFnArgs, 'signal'> => {
  const user = useUser();
  const appView = useAppView();

  return {
    access_token: user.token ?? '',
    baseUrl: appView.baseUrl,
  };
};
